import { connect } from 'react-redux';

import { loadPossibleCyclesForUser } from '../actions/accountSettingsAction';
import {
  loadDashboardHeaderInfo,
  resetPracticeExamHistory,
  setUserCycle,
} from '../actions/dashboardActions';
import {
  getWeeklyPracticeExams,
  setSubmitPracticeExamSuccess,
  submitPracticeExam,
} from '../actions/practiceExamActions';
import { getLoggedStudent } from '../actions/userActions';
import {
  getPossibleCyclesForUser,
  getSwitchPfeSkt,
  getSwitchPfeSktWaiting,
  getUpdateCycleWaiting,
  getUserSubscription,
} from '../components/AccountSettings/AccountSettingsSelectors';
import {
  getDashboardHeaderInfo,
  getDashboardHeaderInfoWaiting,
} from '../components/Dashboard/dashboardSelectors';
import DashboardHeaderView from '../components/Headers/DashboardHeader/completeDashboardHeader';
import {
  getPracticeExam,
  getResultsSummarized,
  getTimer,
} from '../components/PracticeExam/PracticeExamSelectors';
import { getUser } from '../components/User/userSelectors';

const mapStateToProps = (state) => ({
  user: getUser(state),
  possibleCyclesForUser: getPossibleCyclesForUser(state),
  dashboardHeaderInfo: getDashboardHeaderInfo(state),
  dashboardHeaderInfoWaiting: getDashboardHeaderInfoWaiting(state),
  updateCycleWaiting: getUpdateCycleWaiting(state),
  userSubscription: getUserSubscription(state),
  timer: getTimer(state),
  resultsSummarized: getResultsSummarized(state),
  practiceExam: getPracticeExam(state),
  submitPracticeExamSuccess: setSubmitPracticeExamSuccess(state),
  pfeSktId: getSwitchPfeSkt(state),
  pfeSktIdWaiting: getSwitchPfeSktWaiting(state),
});

const mapDispatchToProps = (dispatch) => ({
  loadDashboardHeaderInfo: () => dispatch(loadDashboardHeaderInfo()),
  loadPossibleCyclesForUser: (user) =>
    dispatch(loadPossibleCyclesForUser(user)),
  setUserCycle: (cycleId) => dispatch(setUserCycle(cycleId)),
  getUserData: () => dispatch(getLoggedStudent()),
  resetPracticeExamHistory: () => dispatch(resetPracticeExamHistory()),
  getWeeklyPracticeExams: () => dispatch(getWeeklyPracticeExams()),
  submitPracticeExam: (practiceExam, resultsSummarized, isCustom) =>
    dispatch(submitPracticeExam(practiceExam, resultsSummarized, isCustom)),
});

const DashboardHeaderContainer = connect(
  mapStateToProps,
  mapDispatchToProps,
)(DashboardHeaderView);

export default DashboardHeaderContainer;
